import React from 'react';
import { Box, Container, Heading, Text, VStack, useColorModeValue } from '@chakra-ui/react';

const TermsOfService: React.FC = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const cardBg = useColorModeValue('white', 'gray.700');

  return (
    <Box bg={bgColor} py={20} minH="100vh">
      <Container maxW="container.lg">
        <Box bg={cardBg} p={10} borderRadius="lg" shadow="md">
          <Heading as="h1" size="2xl" mb={6} color={useColorModeValue('brand.700', 'brand.200')}>
            Terms of Service
          </Heading>
          
          <VStack align="start" spacing={6}>
            <Text fontSize="lg" color="gray.600" lineHeight="tall">
              Welcome to MarketLink, a platform that connects farmers and agro dealers with buyers across Zimbabwe directly.
              By accessing or using our website and services you agree to these Terms.
            </Text>

            <Box w="full">
              <Heading as="h2" size="xl" mb={4} color={useColorModeValue('brand.600', 'brand.200')}>
                Who We Are
              </Heading>
              <Text fontSize="md" color="gray.600">
                MarketLink is a digital agro marketplace. We provide the platform only. We do not buy, sell, store or deliver agricultural products. We also do not charge commission or transaction fees on sales made between users.
              </Text>
            </Box>

            <Box w="full">
              <Heading as="h2" size="xl" mb={4} color={useColorModeValue('brand.600', 'brand.200')}>
                Our Role: Platform Only, No Commission
              </Heading>
              <VStack align="start" spacing={2} pl={6} color="gray.600">
                <Text>• <strong>Direct Connection:</strong> We connect farmers, agro dealers and buyers to trade directly with each other.</Text>
                <Text>• <strong>No Commission:</strong> All transactions are free of platform commission. Payment and delivery terms are agreed directly between buyer and seller.</Text>
                <Text>• <strong>No Liability For Transactions:</strong> We are not a party to any contract between users. We are not responsible for product quality, pricing, payment, delivery or disputes.</Text>
              </VStack>
            </Box>

            <Box w="full">
              <Heading as="h2" size="xl" mb={4} color={useColorModeValue('brand.600', 'brand.200')}>
                User Responsibilities
              </Heading>
              <VStack align="start" spacing={2} pl={6} color="gray.600">
                <Text>• <strong>Be Eligible:</strong> Be 18 years and above and legally able to enter contracts in Zimbabwe.</Text>
                <Text>• <strong>Accurate Information:</strong> Provide details for listings, profile and contact. Farmers/Agro dealers must accurately describe products, quantity, location and price.</Text>
                <Text>• <strong>Legal Compliance:</strong> Comply with all Zimbabwean Laws including the Agricultural Marketing Authority Act, seed laws and pesticide regulations. No illegal or banned products.</Text>
                <Text>• <strong>Safe Trading:</strong> Arrange payments and logistics directly. We recommend meeting in safe, public places and using trusted payment methods.</Text>
                <Text>• <strong>No Misuse:</strong> Do not post spam, false listings or use the platform for fraud.</Text>
              </VStack>
              <Box mt={4} p={4} bg={useColorModeValue('yellow.50', 'yellow.900')} borderLeft="4px solid" borderColor="yellow.400" borderRadius="md">
                <Text color={useColorModeValue('yellow.800', 'yellow.200')}>
                  <em>If you want to terminate the contract you simply log out.</em>
                </Text>
              </Box>
            </Box>

            <Box w="full">
              <Heading as="h2" size="xl" mb={4} color={useColorModeValue('brand.600', 'brand.200')}>
                Listings & Content
              </Heading>
              <VStack align="start" spacing={2} pl={6} color="gray.600">
                <Text>• You own the content you post. By posting, you give us a license to display it on the platform.</Text>
                <Text>• We may suspend or terminate accounts that violate these Terms, post fraudulent listings or harm other users.</Text>
              </VStack>
            </Box>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsOfService;
